import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'app-ds-icon',
	templateUrl: './ds-icon.component.html',
	styleUrl: './ds-icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DsIconComponent {
	@Input() name!: string;
}
